var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.892.582c-4.803 0-9.095 2.491-9.095 7.095 0 5.28 7.612 5.645 7.612 8.297 0 1.117-1.279 2.117-3.462 2.117-3.1 0-5.416-1.397-5.416-1.397l-.991 4.646s2.668 1.18 6.21 1.18c5.252 0 9.384-2.615 9.384-7.297 0-5.58-7.644-5.933-7.644-8.395 0-.875 1.05-1.833 3.227-1.833 2.457 0 4.462 1.015 4.462 1.015l.97-4.487S47.968.582 44.892.582zM.95.92l-.116.677s2.02.37 3.84 1.109c2.344.847 2.51 1.34 2.905 2.87l4.3 16.594h5.765L26.524.92h-5.75l-5.707 14.448-2.329-12.247c-.213-1.401-1.295-2.2-2.619-2.2H.95zm27.888 0l-4.512 21.25h5.484L34.306.92h-5.468zm30.588 0c-1.322 0-2.023.709-2.537 1.947L48.854 22.17h5.751l1.113-3.217h7.007l.676 3.217h5.075L64.05.92h-4.623zm.748 5.741l1.705 7.974h-4.567l2.862-7.974z",
    fill: "#fff"
  })));
}

export default SvgVisa;